import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Login from 'screens/Login';
import { login } from 'redux-modules/modules/user';

const mapStateToProps = (state) => ({
  user: state.user.data
});

const mapDispatchToProps = (dispatch, props) => ({
  login: bindActionCreators(login, dispatch),
  redirectToHome: () => props.history.replace('/'),
})

export default connect(mapStateToProps, mapDispatchToProps)(Login);



// WEBPACK FOOTER //
// ./src/containers/Login.js